import React from "react";
import "./../../App.css"
import "./Location.css";
import {Business, BusinessLocation} from "../../types/Types";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBeerMugEmpty, faCreditCard, faLocationDot, faUtensils} from "@fortawesome/free-solid-svg-icons";
import {cityColour} from "../../utils/Utils";
import {url} from "inspector";

interface Props {
  location: BusinessLocation,
  business: Business | undefined,
  displayCard: boolean,
  distance: number | undefined,
}

function LocationRow(props: Props) {
  if(!props.business) {
    return <></>
  }

  return (
      <div className={"location-container mt-0 mb-2"} style={{backgroundImage: `url(${props.location.configuration.locationImageUrl})`}}>
        <div>
          {props.displayCard && <div className={"tag float-right ms-2 bg-blue font-1-2"}><FontAwesomeIcon icon={faCreditCard} /></div>}
        </div>

        <div className={"font-1-8 tag black-80"}><b>{props.business.name}</b></div>

        <div className={"mt-1"}>
          {props.location.typeTags.sellsFood && <div className={"tag black-80 font-1-2 d-inline-block me-1"}><FontAwesomeIcon icon={faUtensils}/></div>}
          {props.location.typeTags.sellsAlcohol && <div className={"tag black-80 font-1-2 d-inline-block"}><FontAwesomeIcon icon={faBeerMugEmpty}/></div>}
          {props.distance != undefined && <span className={"tag black-80 location-distance font-1-2 ms-2"}>{props.distance}km <FontAwesomeIcon icon={faLocationDot} /></span>}
        </div>

        <div>
          <div className={"location-address tag black-80"}>
            <div className={"d-inline-block me-1"}>{props.location.address}</div>
            <div className={"tag d-inline-block font-md ms-1"} style={{backgroundColor: cityColour(props.location.city)}}>{props.location.city}</div>
          </div>
        </div>
      </div>
  )
}

export default LocationRow;